import Academics from "../components/pages/Academics";

export default Academics;
